// Web-Audio-only typewriter tick used during SSE narrative streaming.
// Zero dependencies, respects the same mute flag as AdaptiveAudio.
const MUTE_KEY = "ember_audio_muted_v1";
let ctx = null;
let lastTick = 0;

function isMuted() {
  try { return localStorage.getItem(MUTE_KEY) === "1"; }
  catch { return false; }
}

/** Call once from a user-gesture handler (button click) to unlock AudioContext. */
export function initTypewriterSfx() {
  if (!ctx) {
    try {
      const AC = window.AudioContext || window.webkitAudioContext;
      if (AC) ctx = new AC();
    } catch { /* noop */ }
  }
  if (ctx && ctx.state === "suspended") {
    ctx.resume().catch(() => {});
  }
}

/** Play a short wooden tick. No-op if muted, no context, or throttled. */
export function playTypewriterTick() {
  if (isMuted() || !ctx) return;
  const now = performance.now();
  if (now - lastTick < 45) return;  // rate-limit ~22 ticks/sec max
  lastTick = now;
  try {
    const t = ctx.currentTime;
    const osc = ctx.createOscillator();
    const gain = ctx.createGain();
    osc.type = "square";
    // Small pitch jitter so consecutive ticks don't feel mechanical.
    osc.frequency.setValueAtTime(85 + Math.random() * 40, t);
    gain.gain.setValueAtTime(0.0001, t);
    gain.gain.exponentialRampToValueAtTime(0.05, t + 0.004);
    gain.gain.exponentialRampToValueAtTime(0.0001, t + 0.04);
    osc.connect(gain).connect(ctx.destination);
    osc.start(t);
    osc.stop(t + 0.05);
  } catch { /* noop */ }
}
